// extracted by mini-css-extract-plugin
module.exports = {"new-input":"Coaches_new-input__1xFNg"};